<template>
  <div class="word-grid">
    <div class="word-card">
      <div class="section-title negative">Detractores</div>
        <div class="word-cloud">
          <span v-for="item in wordCloud.detractors" :key="`d-${item.word}`" class="word-chip word-tag" :style="tagStyle('detractors', item.word)">
            {{ item.word }}
          </span>
          <div v-if="!wordCloud.detractors.length" class="empty-state">Sin palabras</div>
        </div>
    </div>
    <div class="word-card">
      <div class="section-title neutral">Neutros</div>
        <div class="word-cloud">
          <span v-for="item in wordCloud.neutrals" :key="`n-${item.word}`" class="word-chip word-tag" :style="tagStyle('neutrals', item.word)">
            {{ item.word }}
          </span>
          <div v-if="!wordCloud.neutrals.length" class="empty-state">Sin palabras</div>
        </div>
    </div>
    <div class="word-card">
      <div class="section-title positive">Promotores</div>
        <div class="word-cloud">
          <span v-for="item in wordCloud.promoters" :key="`p-${item.word}`" class="word-chip word-tag" :style="tagStyle('promoters', item.word)">
            {{ item.word }}
          </span>
          <div v-if="!wordCloud.promoters.length" class="empty-state">Sin palabras</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaWordCloudSection',
  props: {
    wordCloud: {
      type: Object,
      default: function () {
        return {
          promoters: [],
          neutrals: [],
          detractors: []
        };
      }
    }
  },
  methods: {
    tagStyle (type, word) {
      const palette = {
        detractors: [
          { background: '#FECACA', color: '#991B1B' },
          { background: '#FCA5A5', color: '#7F1D1D' },
          { background: '#FBCFE8', color: '#9D174D' },
          { background: '#FEE2E2', color: '#B91C1C' }
        ],
        neutrals: [
          { background: '#FEF08A', color: '#713F12' },
          { background: '#FDE68A', color: '#78350F' },
          { background: '#FEF3C7', color: '#92400E' },
          { background: '#FDE047', color: '#713F12' }
        ],
        promoters: [
          { background: '#BBF7D0', color: '#14532D' },
          { background: '#DCFCE7', color: '#166534' },
          { background: '#86EFAC', color: '#14532D' },
          { background: '#A7F3D0', color: '#065F46' }
        ]
      };
      const tone = palette[type][this.wordIndex(word, palette[type].length)];

      return {
        background: tone.background,
        color: tone.color
      };
    },
    wordIndex (word, size) {
      let hash = 0;
      String(word).split('').forEach((char) => {
        hash = ((hash << 5) - hash) + char.charCodeAt(0);
        hash |= 0;
      });

      return Math.abs(hash) % size;
    }
  }
};
</script>

<style scoped>
.word-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
}

.word-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 250px;
  padding: 20px 22px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}

.word-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 0;
  max-height: 200px;
  overflow-y: auto;
}

.word-chip {
  border-radius: 20px;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 3px 10px;
}

.negative {
  color: #c62828;
}

.neutral {
  color: #ef6c00;
}

.positive {
  color: #2e7d32;
}

.empty-state {
  color: rgba(0, 0, 0, .54);
  font-size: 12px;
}

@media (max-width: 900px) {
  .word-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/WordCloudSection.vue